import React from 'react'
import LineStroke from '../line-stroke';
import NextImage from '@/components/NextImage';

const NoData = ({ className = "", heading = "No Data", errorMsg = '' }) => {
    return (
        <div className={'max-w-6xl mx-auto p-4 py-2 flex flex-col items-center justify-center gap-10 ' + className}>
            <div className='flex flex-col gap-8 sm:gap-4'>
                <div className='w-52 mx-auto'>
                    <LineStroke />
                </div>
                <h1 className='text-[40px] sm:text-2xl font-bold leading-[56px] text-center text-gray-900'>{heading}</h1>
                <p>{errorMsg}</p>
            </div>
            <NextImage
                src='/images/no-data.svg'
                className='w-full h-96'
            />
        </div>
    )
}

export default NoData;
